import { render, staticRenderFns } from "./UploadDocumentAlt.vue?vue&type=template&id=4a91d53e&scoped=true&"
import script from "./UploadDocumentAlt.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentAlt.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentAlt.vue?vue&type=style&index=0&id=4a91d53e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91d53e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDialog,VFileInput,VIcon,VRow,VTextField})
